import React from "react";
import { MwInputText, MwSelector } from "../../ui";
import { useTranslation } from "react-i18next";

const AdvancedForm = ({
  errors,
  customerAccountNo,
  setCustomerAccountNo,
  customerVatNo,
  setCustomerVatNo,
  customerCr,
  setCustomerCr,
  limitCredit,
  setLimitCredit,
  paymentDuringDays,
  setPaymentDuringDays,
  listPriceSelected,
  setListPriceSelected,
  listPrice,
}) => {
  const [t] = useTranslation("global");

  return (
    <>
      <div className="flex gap-4">
        <div className="flex-1 py-2">
          <MwInputText
            label={t("customers.vatNumber")}
            id="customerVatNo"
            value={customerVatNo}
            onChange={(e) => setCustomerVatNo(e.target.value)}
          />
        </div>
        <div className="flex-1 py-2">
          <MwInputText
            label={t("customers.customerCr")}
            id="cutomer_cr"
            value={customerCr}
            onChange={(e) => setCustomerCr(e.target.value)}
          />
        </div>
        <div className="flex-1 py-2">
          <MwInputText
            label={t("customers.accountNumber")}
            id="customerAccountNo"
            value={customerAccountNo}
            onChange={(e) => setCustomerAccountNo(e.target.value)}
          />
        </div>
      </div>

      <div className="py-2 flex gap-4 items-center ">
        <div className="flex-1">
          <MwInputText
            label={t("customers.creditLimit")}
            id="limitCredit"
            inputType="Number"
            value={limitCredit}
            invalid={!!errors.limitCredit}
            invalidMsg={errors.limitCredit}
            onChange={(e) => setLimitCredit(e.target.value)}
          />
        </div>
        <div className="flex-1 flex gap-1">
          <div className="flex-1">
            <MwInputText
              label={t("customers.paymentPeriod")}
              id="paymentDuringDays"
              inputType="Number"
              value={paymentDuringDays}
              invalid={!!errors.paymentDuringDays}
              invalidMsg={errors.paymentDuringDays}
              onChange={(e) => setPaymentDuringDays(e.target.value)}
            />
          </div>
          <div className="w-8 flex items-center justify-center pt-3">
            {t("customers.days")}
          </div>
        </div>
        <div className="flex-1 py-2 relative">
          <MwSelector
            label={t("customers.priceList")}
            initalValue={t("customers.selectPriceList")}
            _data={listPrice}
            dataType="labelValue"
            withAddNew={false}
            setSelectedItem={setListPriceSelected}
            selectedItem={listPriceSelected}
          />
        </div>
      </div>
    </>
  );
};

export default AdvancedForm;

